import Layout from "../components/Layout";

export default function Resume() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto rounded-2xl backdrop-blur-3xl border border-white/20 p-8 md:p-12 bg-white/10 dark:bg-white/5 shadow-lg font-inter animate-fadeIn">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-3">
            Siddhanth Murthy
          </h1>
          <div className="flex flex-wrap justify-center gap-3 text-sm opacity-80">
            <a
              href="tel:+447449537938"
              className="hover:text-cyan-400 transition"
            >
              +44 7449 537 938
            </a>
            <span>•</span>
            <a
              href="mailto:siddhanth.murthy@kcl.ac.uk"
              className="hover:text-cyan-400 transition"
            >
              siddhanth.murthy@kcl.ac.uk
            </a>
            <span>•</span>
            <a
              href="https://linkedin.com/in/sidmurthy"
              target="_blank"
              rel="noreferrer"
              className="hover:text-cyan-400 transition"
            >
              linkedin.com/in/sidmurthy
            </a>
          </div>
        </div>

        {/* Education */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-3 border-b border-cyan-400/30 pb-1">
            Education
          </h2>

          <div className="space-y-4">
            <div>
              <p className="font-medium text-lg">MSc Computer Science</p>
              <p className="text-sm opacity-80">
                King’s College London — 2025–Present, London, UK
              </p>
            </div>

            <div>
              <p className="font-medium text-lg">IB Diploma</p>
              <p className="text-sm opacity-80">
                Emirates International School – Jumeirah — 2025, Dubai, UAE
              </p>
            </div>
          </div>
        </section>

        {/* Work Experience */}
        <section>
          <h2 className="text-2xl font-semibold mb-3 border-b border-cyan-400/30 pb-1">
            Work Experience
          </h2>

          <div className="space-y-8">
            {/* MOREX */}
            <div>
              <div className="flex justify-between flex-wrap mb-1">
                <p className="font-medium text-lg">
                  AI Research Intern — MOREX Industrial Corporation
                </p>
                <p className="text-sm opacity-70">
                  July 2024 – September 2024 · Mumbai, India
                </p>
              </div>
              <ul className="list-disc list-inside text-sm opacity-90 space-y-1">
                <li>
                  Worked directly with the CEO & Head of Business Operations to
                  improve factory efficiency and strategy.
                </li>
                <li>
                  Researched and implemented AI/automation to enhance quality
                  assurance and worker training via AR technologies.
                </li>
                <li>
                  Developed automation workflows and data-driven tools tailored
                  to optimize manufacturing operations.
                </li>
              </ul>
            </div>

            {/* Al Habtoor */}
            <div>
              <div className="flex justify-between flex-wrap mb-1">
                <p className="font-medium text-lg">
                  Business Strategy Intern — Al Habtoor Motors
                </p>
                <p className="text-sm opacity-70">
                  June 2024 – July 2024 · Dubai, UAE
                </p>
              </div>
              <ul className="list-disc list-inside text-sm opacity-90 space-y-1">
                <li>
                  Analyzed workflows and revenue models across a dealership
                  network serving 30,000+ customers.
                </li>
                <li>
                  Designed a risk-assessment framework that improved
                  identification of operational risks by 15%.
                </li>
                <li>
                  Worked with SAP CRM (150,000+ client records), improving
                  performance metrics via SEO & SEM insights.
                </li>
              </ul>
            </div>

            {/* RevisionDojo */}
            <div>
              <div className="flex justify-between flex-wrap mb-1">
                <p className="font-medium text-lg">
                  Software Engineer Intern — RevisionDojo
                </p>
                <p className="text-sm opacity-70">
                  October 2023 – March 2024 · Remote
                </p>
              </div>
              <ul className="list-disc list-inside text-sm opacity-90 space-y-1">
                <li>
                  Developed and integrated 5 GPT-powered AI assistants for
                  subject-specific learning experiences.
                </li>
                <li>
                  Rebuilt the search system with dynamic filters, query parsing,
                  and user analytics.
                </li>
                <li>
                  Improved model inference speed and optimized AI-assisted
                  learning features.
                </li>
              </ul>
            </div>

            {/* Z10 Studios */}
            <div>
              <div className="flex justify-between flex-wrap mb-1">
                <p className="font-medium text-lg">
                  Co-Founder & Lead Developer — Z10 Studios
                </p>
                <p className="text-sm opacity-70">
                  June 2022 – July 2024 · Dubai, UAE
                </p>
              </div>
              <ul className="list-disc list-inside text-sm opacity-90 space-y-1">
                <li>
                  Led digital transformation projects for foreign clients using
                  React, Python, and AI-driven automation.
                </li>
                <li>
                  Boosted client engagement by 250% and interactions by 800%
                  through two high-impact redesigns.
                </li>
                <li>
                  Deployed SEO/SEM strategies to strengthen brand visibility and
                  user engagement.
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}
